import {
  Button,
  Col,
  DatePicker,
  Input,
  Layout,
  Pagination,
  Popover,
  Row,
  Select,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";

import { FaPlus } from "react-icons/fa";
import { IoSearchSharp } from "react-icons/io5";
import { useNavigate } from "react-router";
import Card from "../../components/card";

import { FaFilter, FaSearch } from "react-icons/fa";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Get } from "../../config/api/get";
import { COMMUNITY } from "../../config/constants/api";

export default function Community() {
  const navigate = useNavigate();

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const [allPost, setAllPost] = useState([]);
  const [open, setOpen] = useState(false);

  function search() {
    alert(value);
  }


  // pagindation
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 14,
    totalDocs: 0,
    totalPages: 0,
  });

  const getPosts = async (pageNumber, pageSize, search, reset = false) => {
    try {
      const response = await Get(COMMUNITY.getAllPost, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        status: reset ? "" : filter.status || null,
        type: reset ? "" : filter.type || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });

      setLoading(false);

      if (response.status === true) {
        setAllPost(response?.data);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        // swal("Error", "Something went wrong", "error")
        console.log("error====>", response);
      }
    } catch (error) {
      setLoading(false);
      swal("Error", error?.message || "something went wrong", "error");
      console.log(error);
    }
  };

  useEffect(() => {
    getPosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getPosts(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      status: value,
    });
  };

  const handleTypeChange = (value) => {
    setFilter({
      ...filter,
      type: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getPosts(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <button type="button" style={{ background: "none", border: "none", cursor: "pointer", color: "inherit", padding: 0 }}>Previous</button>;
    }
    if (type === "next") {
      return <button type="button" style={{ background: "none", border: "none", cursor: "pointer", color: "inherit", padding: 0 }}>Next</button>;
    }
    return originalElement;
  };

  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p className="mainLabel" style={{ padding: "10px" }}>
          Filter
        </p>
      </div>
      <hr style={{ margin: 0 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">Lesson Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          placeholder="From"
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          placeholder="To"
        />

        <p className="mainLabel">Lesson Type:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Lesson Type"
          value={filter.type}
          onChange={(e) => handleTypeChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "TUTORING", label: "Training" },
            { value: "COACHING", label: "Consulting" },
          ]}
        />

        <p className="mainLabel">Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "PENDING", label: "Pending" },
            { value: "UPCOMING", label: "Upcoming" },
          ]}
        />

        <Button
          type="primary"
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="loginButton"
          onClick={() => {
            getPosts();
          }}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
       <Row
        className="blueBackground communitybnr relative"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {/* Black Overlay */}
        <div className="absolute inset-0 bg-black opacity-50 z-0"></div>

        {/* Content */}
        <Typography.Title
          className="fontFamily1 relative z-10"
          style={{
            fontSize: "30px",
            color: "black",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <div className="flex w-full h-full justify-center flex-col gap-5 items-center">
            <h2 className="text-4xl md:text-5xl whitespace-nowrap text-white font-extrabold">
              Find your community
            </h2>
            <h2 className="text-2xl md:text-3xl text-white font-semibold" style={{marginTop:"0"}}>
              From education, learning, there's a place for you.
            </h2>

            <div className="relative">
              <input
                type="text"
                style={{fontSize:"14px"}}
                placeholder="Explore Discussion"
                className="w-[280px] md:w-[500px] h-12 focus:ring-0 focus:outline-none p-6 rounded-lg border-2 border-gray-300"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    search();
                  }
                }}
              />

              <IoSearchSharp
                onClick={search}
                size={20}
                className="absolute right-2 top-3"
              />
            </div>
          </div>
        </Typography.Title>
      </Row>

      {/* <Row className="md:mx-24 my-10">
        <div
          className="bg-cover bg-center px-10 sm:px-24 w-full"
          style={{ backgroundImage: `url(${frameImage})`, height: "400px" }}
        >
          <div className="flex w-full h-full justify-center flex-col gap-5 items-center">
            <h2 className="text-4xl md:text-5xl whitespace-nowrap text-white font-extrabold">
              Find your community
            </h2>
            <h2 className="text-2xl md:text-3xl text-white font-semibold">
              From education, learning, there's a place for you.
            </h2>

            <div className="relative">
              <input
                type="text"
                placeholder="Explore Discussion"
                className="w-[280px] md:w-[500px] h-12 focus:ring-0 focus:outline-none  p-6 rounded-lg border-2 border-gray-300"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    search();
                  }
                }}
              />

              <IoSearchSharp
                onClick={search}
                size={20}
                className="absolute right-2 top-3"
              />
            </div>
          </div>
        </div>
      </Row> */}

      <Row className="mx-4 md:mx-24 mb-5" style={{paddingTop:"20px"}}>
        <Col xs={24} md={12}></Col>
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Popover
            content={filterContent}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
            placement="bottomRight"
            arrow={false}
          >
            <Button
              shape="circle"
              style={{
                padding: "12px 12px 5px",
                height: "auto",
                backgroundColor: "#00a79d",
              }}
            >
              <FaFilter style={{ fontSize: "16px", color: "white" }} />
            </Button>
          </Popover>
          &emsp;
          <Input
            style={{ width: "250px" }}
            className="mainInput dashInput"
            placeholder="Search Here"
            onChange={(e) => handleSearch(e.target.value)}
            suffix={
              <FaSearch
                style={{
                  color: "grey",
                  fontSize: 16,
                  cursor: "pointer",
                }}
                onClick={() =>
                  getPosts(1, paginationConfig.limit, filter.keyword)
                }
              />
            }
            onPressEnter={(e) =>
              getPosts(1, paginationConfig.limit, filter.keyword)
            }
          />
        </Col>
      </Row>

      {/* <Row className='md:mx-24 my-10 flex-row md:flex-row flex md:flex-wrap gap-7 justify-center md:justify-start items-center'> */}
      <Row className="md:mx-20 grid-Container">
        {loading ? (
          <>
            <div className="flex justify-center items-center  gap-5">
              <p className="text-3xl font-semibold">Loading</p>
              <div class="w-12 h-12 border-4 border-dashed border-t-4 border-blue-500  rounded-full animate-spin"></div>
            </div>
          </>
        ) : (
          <>
            <div className="min-h-[320px] rounded-2xl  box-border border-[1px] border-slate-400 flex flex-col items-start ">
              <div className="flex mx-auto justify-center items-center flex-col gap-5">
                <div
                  onClick={() => navigate("/create-form")}
                  className="w-32 h-32 bg-blue-500 hover:bg-blue-600 rounded-full flex justify-center items-center"
                >
                  <FaPlus size={32} className="text-white" />
                </div>
                <p className="text-3xl font-bold">Add New</p>
              </div>
            </div>

            {allPost?.docs?.map((post, i) => (
              <Card post={post} key={i} />
            ))}
          </>
        )}
      </Row>

      <Row className="md:mx-24 my-10">
        <Col xs={24} md={12}>
          <p
            className="fontFamily1 text-center my-3 md:my-0 md:text-start"
            style={{ color: "#999" }}
          >
            {message}
          </p>
        </Col>
        <Col xs={24} md={12} className="flex md:justify-end justify-center">
          <Pagination
            className="styledPagination"
            onChange={(e) => handlePageChange(e)}
            current={parseInt(paginationConfig.pageNumber)}
            pageSize={paginationConfig.limit}
            total={paginationConfig.totalDocs}
            itemRender={itemRender}
          />
        </Col>
      </Row>
    </Layout>
  );
}
